import { render } from "./CategoriesList.vue?vue&type=template&id=22322cce&ts=true"
import script from "./CategoriesList.vue?vue&type=script&lang=ts"
export * from "./CategoriesList.vue?vue&type=script&lang=ts"

import "./CategoriesList.vue?vue&type=style&index=0&id=22322cce&lang=css"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__